import styled from 'styled-components';

import { baseFontFamily, baseFontSize, baseLineHeight } from 'views/services/font-scheme';
import { baseColor, lineColor, primaryColor } from 'views/services/color-scheme';
import { HEIGHT as headerHeight } from 'views/components/header';
import { HEIGHT as footerHeight } from 'views/components/footer';

export const Root = styled.div`
  position: relative;
  min-height: calc(100vh - ${headerHeight} - ${footerHeight});
  font-family: ${baseFontFamily};
  font-size: ${baseFontSize};
  line-height: ${baseLineHeight};
  color: ${lineColor};
  h1, h2 {
    font-size: calc(${baseFontSize} * 1.3);
    font-weight: normal;
  }
  h1 {
    color: ${baseColor};
  }
  h2 {
    color: ${primaryColor};
  }
`;